const ElementPrefixId = {
  MODAL_BACKUP_AND_RESTORE_DATA: 'modal-backup-and-restore-data',
  MODAL_DOWNLOAD_BACKUP_DATA_FAILED: 'modal-download-backup-data-failed',
  MODAL_HUMIDIFIER_DISCONNECTED: 'modal-humidifier-disconnected',
  MODAL_CANNOT_USE_THIS_FEATURE: 'modal-cannot-use-this-feature',
  MODAL_INSTRUMENT_NON_OPERATIONAL: 'modal-instrument-non-operational',
};

export default ElementPrefixId;
